module.exports = __webpack_public_path__ + "img/mdcmap.026c2cd1.png";